export default "__VITE_ASSET__CuchlpCw__"